//@ts-ignore this works perfectly fine.
import { PatientInviteComponent } from './../../../app/shared-components/patient-invite/patient-invite.component';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, Routes } from '@angular/router';
// @ts-ignore
import { allowOnlyProfessionals, requireRoles } from '../../../../src/app/services/routePermissions.guard';
import { ApiService } from '../../../app/services/api/api.service';
import { inject } from '@angular/core';
import { callbacksSlug, eCITSlug, navigateToLoginAndRedirectAfter, profileSlug, relatedUserSlug, requestPasswordSlug, resetPasswordSlug, oidcCallbackSlug, userLoginSlug } from './app.paths';

//@ts-ignore this works perfectly fine.
import { CustomSearchConfig } from '../../../app/pages/forms/generic-search/generic-search.component';
import { WithPinning } from './app.path.types';
import { withPinningDefault } from '../../shared/staticConfig';

const requireLoggedIn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot)=> {
  const apiServiceRef = inject(ApiService);
  const router = inject(Router);
  const isAuthenticated = await apiServiceRef.isAuthenticated(); // will wait for max. 3 seconds for state.user to be defined

  console.devlog(isAuthenticated, "isAuthenticated in requireLoggedIn guard")

  if (!isAuthenticated) {
    navigateToLoginAndRedirectAfter(router, state.url as `/${string}`);
    return false;
  }

  return true;
};

// relatedUser pages are only for the treating professional and their assistants (no admins / groupmanagers)
const allowProfessionalAndAssistant = requireRoles(['authenticated_professional', 'assistant']);

export const RELATED_USER_SEARCH_CONFIG : CustomSearchConfig = {
  searchFn: async (api: ApiService, searchString: string): Promise<any[]>=>{
    const result = await api.findRelatedUsers({_contains: searchString})
    return result as any[]
  },
  showLocalToggle: false,
  rowClickFn: (router: Router, rowData: any): void =>{
    router.navigate(['/f', relatedUserSlug, rowData.documentId, 'info'])
  }
}

export const routes: Routes = [
  {
    path: "",
    loadChildren: () =>
      import("./home/home.module").then((m) => m.NgdHomeModule),
  },
  {
    path: "about-us",
    loadComponent: () => import("./pages/home/home.component").then((m) => m.HomePageComponent),
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pages/about/about.component").then((m) => m.AboutComponent),
      },
    ],
  },
  {
    path: userLoginSlug,
    loadComponent: () => import("./pages/home/home.component").then((m) => m.HomePageComponent),
    children: [
      {
        path: "",
        loadComponent: () => import("./pages/user-login-wrapper/user-login-wrapper.component").then((m) => m.UserLoginWrapperComponent),
      },
    ],
  },
  {
    path: 'confirm',
    loadComponent: () => import('./pages/home/home.component').then((m) => m.HomePageComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/accept-invite/accept-invite').then((m) => m.AcceptInviteComponent),
      }
    ]
  },
  {
    path: "home",
    loadComponent: () =>
      import("./pages/home/home.component").then((m) => m.HomePageComponent),
    children: [
      {
        path: "",
        loadComponent: () => import("./pages/home/content/HomePageContent.component").then((m) => m.HomePageContentComponent),
      },
    ],
    canActivate: [requireLoggedIn],
    // canActivate: [async ()=> { return (true)}],
  },
  {
    path: requestPasswordSlug,
    loadComponent: () => import("./pages/home/home.component").then((m)=>m.HomePageComponent),
    children: [
      {
        path: "",
        loadComponent: ()=> import("../../../../src/app/authentication/components/forgot-password/forgot-password.component").then((m)=> m.NbForgotPasswordComponent)
      }
    ]
    
  },
  {
    path: resetPasswordSlug,
    loadComponent: () => import("./pages/home/home.component").then((m)=>m.HomePageComponent),
    children: [
      {
        path: "",
        loadComponent: ()=> import("../../../../src/app/authentication/components/reset-password/reset-password.component").then((m)=> m.NbResetPasswordComponent)
      }
    ]
  },
  // this is needed as currently, due to the MedPoC frontend using this url as default redirect after login, see processDirectLogin()
  {
    path: "dashboard",
    redirectTo: "home",
    pathMatch: "full",
  },
  // here come the features:
  {
    path: "f",
    loadComponent: () => import("./pages/home/home.component").then((m) => m.HomePageComponent),
    children: [
      // authenticated — for invites that require login (employee, group)
      {
        path: 'confirm',
        loadComponent: () => import('./pages/accept-invite/accept-invite')
          .then(m => m.AcceptInviteComponent),
        canActivate: [requireLoggedIn],
        data: { authenticated: true }, // this is used in AcceptInviteComponent to determine if we're on the public or private route
      },
      {
        path: "appointments",
        //@ts-ignore
        loadComponent: () => import("./../../../../src/app/shared-components/calendar/calendar.component").then((m) => m.CalendarComponent),
        canActivate: [allowOnlyProfessionals],
      },
      {
        path: "forms",
        loadComponent: () => import('../../../../src/app/pages/forms-page/forms-page/forms-page.component')
          .then((m) => m.FormsPageComponent),
        canActivate: [allowOnlyProfessionals],
      },
      {
        path: "forms/:slug",
        loadComponent: () => import('../../../../src/app/pages/forms-page/forms-page/forms-page.component').then((m) => m.FormsPageComponent),
        canActivate: [allowOnlyProfessionals],
      },
      {
        path: "accounting",
        //@ts-ignore
        loadComponent: () => import("./../../../../src/app/shared-components/accounting/accounting.component").then((m) => m.AccountingComponent),
        canActivate: [allowOnlyProfessionals],
      },
      {
        path: "groups",
        //@ts-ignore
        loadComponent: () => import("./../../../../src/app/shared-components/groups/groups.component").then((m) => m.GroupsComponent),
        canActivate: [allowOnlyProfessionals],
      },
      {
        path: "register-patient",
        //@ts-ignore
        loadComponent: () => import("./../../../../src/app/pages/forms/register-patient/register-patient.component").then((m) => m.RegisterPatientComponent),
        canActivate: [allowOnlyProfessionals],
      },
      {
        path: "paymentdetails",
        //@ts-ignore
        loadComponent: () => import("../../../app/shared-components/paymentDetails/paymentDetails.component").then((m) => m.PaymentDetailsComponent),
        canActivate: [requireLoggedIn],
      },
      {
        path: eCITSlug,
        //@ts-ignore
        loadComponent: () => import("../../../app/shared-components/eCIT/e-cit.component").then((m) => m.ECITComponent),
        canActivate: [requireLoggedIn],
      },
      {
        path: `${eCITSlug}/my-ecits`,
        //@ts-ignore
        loadComponent: () => import("../../../app/shared-components/eCIT/myEcit/my-ecits.component").then((m) => m.MyEcitsComponent),
        canActivate: [requireLoggedIn, allowProfessionalAndAssistant],
      },
      {
        path: `${eCITSlug}/my-ecits/:documentId`,
        loadComponent: () => import("../../../app/shared-components/eCIT/myEcit/ecitDetails/ecit-details.component")
          .then((m) => m.EcitDetailsComponent),
        canActivate: [requireLoggedIn, allowProfessionalAndAssistant],
      },
      {
        path: "paymentdetails/payment-link",
        loadComponent: () => import("../../../app/shared-components/paymentDetails/paymentLink/paymentLink.component")
          .then((m) => m.PaymentLinkComponent),
        canActivate: [allowOnlyProfessionals, requireLoggedIn],
      },
      {
        path: "paymentdetails/my-payments",
        loadComponent: () => import("../../../app/shared-components/paymentDetails/paymentLinksSearch/my-payments.component")
          .then((m) => m.MyPaymentsComponent),
        canActivate: [allowOnlyProfessionals, requireLoggedIn],
      },
      {
        path: "paymentdetails/payment-links/:documentId",
        loadComponent: () => import("../../../app/shared-components/paymentDetails/paymentLinksSearch/paymentLinkDetails/payment-link-details.component")
          .then((m) => m.PaymentLinkDetailsComponent),
        canActivate: [allowOnlyProfessionals, requireLoggedIn],
      },
      // related user
      {
        path: relatedUserSlug,
        loadComponent: ()=>
          import(
            "../../../app/pages/forms/generic-search/generic-search.component"
          ).then((m)=>m.GenericSearchComponent),
        canActivate: [requireLoggedIn, allowProfessionalAndAssistant],
        data: {
          customConfig: {
            ...RELATED_USER_SEARCH_CONFIG,
            enableUserPinning: true,
            hidePinning: false,
            afterSearchSlot: PatientInviteComponent,
            useCaseSpecificSettings: {
              delayUntilPinHide: withPinningDefault.delayUntilPinHide, // using global config value for pinning delay on related user search
            }
          } as CustomSearchConfig<WithPinning>
        }
      },
      {
        path: `${relatedUserSlug}/:id/:tab`,
        loadComponent: () =>
          import(
            "../../../app/pages/forms/edit-profile/edit-profile.component" // works perfectly fine. just not ts-ignoring it so eventual real errors will still be caught.
          ).then((m) => m.EditProfileComponent),
        canActivate: [requireLoggedIn, allowProfessionalAndAssistant],
      },
      {
        path: `${relatedUserSlug}/:id`,
        redirectTo: `${relatedUserSlug}/:id/info`,
      },
      
      {
        path: `${profileSlug}/:id/:tab`,
        //@ts-ignore
        loadComponent: () => import("../../../app/pages/forms/edit-profile/edit-profile.component").then((m) => m.EditProfileComponent),
            canActivate: [requireLoggedIn],
      },
      // Redirect /profile/:id → /profile/:id/info
      {
        path: `${profileSlug}/:id`,
        redirectTo: `${profileSlug}/:id/info`,
      },
      // Redirect /profile → /profile/me/info
      {
        path: profileSlug,
        redirectTo: `${profileSlug}/me/info`,
      },
      {
        path: 'logout',
        loadComponent: () => import('./pages/logout/logout.component').then((m) => m.LogoutComponent),
      },
    ],
  },
  {
    path: callbacksSlug,
    loadComponent: () => import("./pages/home/home.component").then((m) => m.HomePageComponent),
    children: [
      {
        path: oidcCallbackSlug,
        //@ts-ignore
        loadComponent: () => import("./../../../../src/app/shared-components/callbacks/oidc/oidc.component").then((m) => m.OidcCallbackComponent),
        // canActivate: [allowOnlyProfessionals],
      },
      {
        path: "",
        redirectTo: "/home",
        pathMatch: "full",
      },
    ],
  },
  {
    path: "**",
    redirectTo: "",
  },
];